import React from 'react';

import { useCheckoutContext } from 'Jsx/CheckoutV4/Context';
import I18N_STRINGS from 'Jsx/CheckoutV4/i18n/language';

import InputField, { ChangeState, Validation } from '../InputField';

import getZipCodeData from './utils/getZipCodeData';
import validateZipCode from './utils/validateZipCode';

export interface ZipCodeState {
  zipCode: string;
  isValid: boolean;
}

export interface ZipCodeInputProps {
  onZipCodeChange: (zipCodeState: ZipCodeState) => void;
}

const ZipCodeInput = ({ onZipCodeChange }: ZipCodeInputProps) => {
  const { countryPrefix } = useCheckoutContext();
  const { maxLength, hint } = getZipCodeData(countryPrefix);

  const validation = (
    event: React.ChangeEvent<HTMLInputElement>,
  ): Validation => {
    const { value } = event.target;

    const zipCodeValidation = validateZipCode({
      country: countryPrefix,
      value,
    });

    return zipCodeValidation;
  };

  const handleChange = ({ value, isValid }: ChangeState) => {
    onZipCodeChange({
      zipCode: value,
      isValid,
    });
  };

  return (
    <InputField
      maxLength={maxLength}
      id="zipCode"
      name="zipCode"
      testId="zipcode-field"
      className="mb-24"
      onChange={handleChange}
      validation={validation}
      label={I18N_STRINGS.ZIP_CODE_LABEL}
      description={hint}
    />
  );
};

export default ZipCodeInput;
